import { apiClient } from "../../shared/api/clients";

/** Période de solde (remise_periode_det) */
export interface SoldePeriode {
  code_periode: string;
  date_deb_priv: string | null;
  date_debut: string | null;
  date_fin: string | null;
  date_debut2: string | null;
  date_debut3: string | null;
  cod_dep: string | null;
  date_debut4: string | null;
}

/** Article dans une période de solde (remise_periode ⟵→ article) */
export interface ArticleSolde {
  code: number;
  code_periode: string | null;
  cod_art: string | null;
  desg_art: string | null;
  reference: string | null;
  barcode: string | null;
  pvuttc: number | null;
  pvttc: number | null;
  pvht: number | null;
  taux: number | null;
  taux2: number | null;
  taux3: number | null;
  taux4: number | null;
  date_debut: string | null;
  date_fin: string | null;
  date_debut2: string | null;
  date_debut3: string | null;
  date_debut4: string | null;
  date_deb_priv: string | null;
  prix_apres_remise: number | null;
}

export const getSoldePeriodes = () =>
  apiClient.get<SoldePeriode[]>("/solde/periodes");

export const getArticlesByPeriode = (codePeriode: string) =>
  apiClient.get<ArticleSolde[]>(`/solde/articles/${encodeURIComponent(codePeriode)}`);
